import type {
  ContentObject,
  ContentTypeDefinition,
  RelationWithoutHydration,
  WithOptionalInternalProps,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type FormRelationAfterSubmitEventInit = {
  /** Content type for the main object form. */
  contentType?: WithOptionalInternalProps<ContentTypeDefinition> | null;
  /** Main content object currently editing. */
  contentObject?: WithOptionalInternalProps<ContentObject> | null;
  /** Name of the relation field. */
  fieldName: string;
  /** Relation field value. */
  relation: RelationWithoutHydration;
  /** Relation content object without hydration. */
  relationContentObject: ContentObject;
  /** Relation content type. */
  relationContentType: ContentTypeDefinition;
  /** If editing relation object was successful. */
  isSuccess: boolean;
  /** Errors of editing relation object. */
  errors?: any;
  /** Form values. */
  values: object;
};

/**
 * An event that is fired when a relation object is edited through another content object form.
 * No result is expected.
 *
 * @eventName "flotiq.form.relation::after-submit"
 * @memberof FlotiqPlugins.Events
 */
export class FormRelationAfterSubmitEvent extends IFlotiqPluginEvent {
  constructor(initData: FormRelationAfterSubmitEventInit) {
    super(initData);
  }
}
